import type { IEntityModel } from './base'
import type { IQuestionnaireDisplayRule } from './questionnaire_display_rule'

export enum IQuestionnaireDisplayLogicType {
  Display = 'display',
  Skip = 'skip',
}

export enum IQuestionnaireDisplayLogicOperator {
  And = 'and',
  Or = 'or',
}

export interface IQuestionnaireDisplayLogic extends IEntityModel {
  displayStrategyId: string
  type: IQuestionnaireDisplayLogicType
  displayRuleList?: IQuestionnaireDisplayRule[] | null
  operator: IQuestionnaireDisplayLogicOperator
}
